import React from 'react'
import MetaContent from '../components/MetaContent'

export default function partnerDirect() {
  const title = 'Partner Direct'
  const description = 'Service to the west coast, with visibility end to end.'

  return (
    <>
      <MetaContent title={title} description={description} />
      <section className="w-full">
        <iframe
          src="https://nopkpartnerdirect.framer.website/"
          title="North Park Transportation Partner Direct"
          style={{ width: '100%', height: '100vh' }}
          className="block border-0"
          loading="lazy"
          allowFullScreen
        />
      </section>
    </>
  )
}
